export enum MutationTypes {
    ADD_NOTIFICATION = "ADD_NOTIFICATION",
    CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION",
    SET_ANONYMOUSSESSIONID = "SET_ANONYMOUSSESSIONID",
}
